import jwtDecode from "jwt-decode";

const HARDCODED_TOKEN = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI1OTc0ZmI4Zi0wZTZmLTQwNTAtYmMzOS1iOGU5OWI3NmNjZTEiLCJuYW1lIjoiQWJ1IEJha2FyIiwiaW1hZ2UiOiJodHRwczovL3dvcmt3LmNvbS9SZXNvdXJjZXNcXDBhYjVmOWMwLWY5NDgtNGM0MC04ZGFkLWM1OGJhOTlmYjc2NVxcSW1hZ2VzXFxiOTFkZDJlMi1mNDEwLTRkYjgtOWVmNC0zMjNmOTFhOGU1NDIuanBnIiwiZW1haWwiOiJhYnViYWthckBtaWxldGFwLmNvbSIsImJ1c2luZXNzSWQiOiIwYWI1ZjljMC1mOTQ4LTRjNDAtOGRhZC1jNThiYTk5ZmI3NjUiLCJ2ZXIiOiJGM0Q1MUE4NC1EMjQ0LTQ2QTgtQTYyNi1DMUFCMjg3NDFBMTMiLCJpaCI6IkJiOFdzSjlXUUNNUVlSL3didDkzcWNKQTBDT0RyYURCTytKdC9qZkhkUm89IiwiaXMiOiJ0VlFOamNQNGwzZWErcEs4Q1c2TzZBPT0iLCJwaCI6Ijd2OS9QcGZBQytzQ3pZSFFwbGNiMllUM2lxS0E2OHpsblNETFQ5R2E5NVE9IiwicHMiOiJPQlh4dStQbFNkUk1uVUloQ3FrbkVBPT0iLCJwbGF0Zm9ybSI6IldlYiIsImlzQWdlbnQiOiJGYWxzZSIsImp0aSI6ImM4MDZlNWIwLTgxMTMtNDJhZC1hZjRhLWEzN2U3ZWU5YTkyMiIsIm5iZiI6MTc4MTM0NDI0NCwiZXhwIjoxNzgxNTE3MDQ0fQ.VDhWRECjDvkpLvF4LKvNbtaAAXxoBGsHuN3p8rtEvO7v441FZukBkZ7Iaz842TzJl52_OQPfVGmSbGj2wC8WGurjooud7vw6MUQEbzp6OcYOnhGMaA3NmXxppBMTYvGoiIxy-R4XT6QGEX5pBGHt0RU2iAGVRSj3g8pZFyzFde5lWZnUebndQAeF2UTM150v4Lc6eyLSkvoS55IHOx6HuyV1811tcjdtEuBViOtAzvq4TrJ13EKSbOIUSD767VuCg-uHU5868tDtZCBHu8DS83_PRsj3oofTyyiIi4S9JYtkSz6CjMfWL1Wc8_Mn6YCBEjjkdpdVcJyw4CkhW6jLHw";

function getCookieValue(name) {
  const regex = new RegExp(`(^| )${name}=([^;]+)`);
  const match = document.cookie.match(regex);
  if (match) {
    return match[2];
  }
}

export function getWorkWiseAuthToken() {
  const searchParams = new URLSearchParams(document.location.search);
  let cookieToken = getCookieValue("token");
  let queryToken = searchParams.get("token");
  const finalToken = queryToken || cookieToken || HARDCODED_TOKEN;
  return finalToken;
}

export function decodeWorkWiseToken() {
  const token = getWorkWiseAuthToken();
  if (!token) return null;
  try {
    const payload = token.split('.')[1];
    const decoded = JSON.parse(atob(payload));
    return decoded;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
}

export const getUserInfoFromToken = () => {
  try {
    const token = getWorkWiseAuthToken();

    if (!token) return null;

    const decoded = jwtDecode(token);

    return decoded || null;
  } catch (error) {
    console.error("Invalid token:", error);
    return null;
  }
};
